export interface IPagination {
    limit?: number;
    page?: number;
    sortOrder?: SortOrderEnum;
    startDate?: string;
    endDate?: string;
}

export enum SortOrderEnum {
    ASC = "ASC",
    DESC = "DESC"
}

export enum Platform {
    DESKTOP = 'desktop',
    MOBILE = 'mobile'
}

export enum PaymentMethod {
    CREDIT_CARD = 'CREDIT_CARD',
    PAYPAL = 'PAYPAL',
    STRIPE = 'STRIPE',
    APPLE_PAY = 'APPLE_PAY',
    GOOGLE_PAY = 'GOOGLE_PAY',
    VIRTUAL_CURRENCY = 'VIRTUAL_CURRENCY',
}

export enum Currency {
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP',
    VIRTUAL = 'VIRTUAL',
}

export enum AccountStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    SUSPENDED = 'SUSPENDED',
    DELETED = 'DELETED',
    ON_REVIEW = 'ON_REVIEW',
}

export interface PaginatedResponse<T> {
    items: T[];
    pagination: {
        total: number;
        page: number;
        limit: number;
        totalPages: number;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
    };
}

export interface PaginationMeta {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export interface FlatPaginatedResponse<T> {
    data: T[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}